import type { GroupedSmartSurveyorElement } from "components/SmartSurveyor/ReviewPage/types";
import type { PlanV3 } from "./types";

export const getFirstElementAcrossGroups = (
  plan: PlanV3 | null,
): GroupedSmartSurveyorElement | null => {
  const groupedElements = plan?.groupedElements;
  if (!groupedElements) return null;
  for (const groupId of groupedElements.groupIds ?? []) {
    const elements = groupedElements.byGroupId?.[groupId];
    if (elements?.[0]) return elements[0];
  }
  return null;
};
